import { render, staticRenderFns } from "./userfrom.vue?vue&type=template&id=a3b3dd44&"
import script from "./userfrom.vue?vue&type=script&lang=js&"
export * from "./userfrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports